export default {
  state: {
    systemMessageList:[],//系统消息集合
    updateMessageStatus:false,  //修改消息后通知head刷新数据
  },
  getters: {
    systemMessageList: state => state.systemMessageList,
    updateMessageStatus: state => state.updateMessageStatus
  },
  mutations: {
    INIT_MESSAGE_LIST: (state,  messageList) => {
      state.systemMessageList =  messageList
    },
    updateMessageStatus: (state,  updateMessageStatus) => {
      state.updateMessageStatus =  updateMessageStatus
    },
  },
  actions: {
    initMessageList({commit}, messageList) {
      return new Promise((resolve) => {
        commit('INIT_MESSAGE_LIST', messageList);
        resolve();
      })
    },
    initUpdateMessageStatus({commit}, updateMessageStatus) {
      return new Promise((resolve) => {
        commit('updateMessageStatus', updateMessageStatus);
        resolve();
      })
    },
  }
}



// WEBPACK FOOTER //
// ./src/store/message.js